/** 
* @description 认证模块 
* @version 0.3.6 
* @author lengyingxin <lengyingxin8966@gmail.com> (https://github.com/LengYXin)
*/
var env = {
  version: "0.3.6",
  timestamp: "2022-11-04 12:57"
};

export { env as default };
//# sourceMappingURL=env.js.map
